import SimpleSchema from 'simpl-schema';

// tslint:disable-next-line:max-line-length
const isoDateRegexp = /^([\+-]?\d{4}(?!\d{2}\b))(?:(-?)(?:(0[1-9]|1[0-2])(?:\2([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))(?:[T\s](?:(?:([01]\d|2[0-3])(?:(:?)([0-5]\d))?|24\:?00)([\.,]\d+(?!:))?)?(?:\10([0-5]\d)([\.,]\d+)?)?([zZ]|([\+-](?:[01]\d|2[0-3])):?([0-5]\d)?)?)?)?$/;

export const fullProfileSchema = new SimpleSchema({
  // emailAddress: { type: String, regEx: SimpleSchema.RegEx.EmailWithTLD },
  gender: {
    allowedValues: ['male', 'female', 'unknown'],
    type: String,
  },
  // tslint:disable-next-line:object-literal-sort-keys
  firstName: {
    min: 1,
    type: String,
  },
  lastName: {
    min: 1,
    type: String,
  },
  nickname: {
    optional: true,
    type: String,
  },
  postalCode: {
    max: 5,
    min: 5,
    type: String,
  },
  street: {
    min: 1,
    type: String,
  },
  city: {
    min: 1,
    type: String,
  },
  birthdayISO: {
    regEx: isoDateRegexp,
    type: String,
  },
  identities: {
    blackbox: true,
    optional: true,
    type: Object,
  },
  phoneNumber: {
    optional: true,
    type: String,
  },
  verifiedFields: {
    blackbox: true,
    optional: true,
    type: Object,
  },
});

export interface IProfile {
  birthdayISO?: string;
  city?: string;
  // emailAddress?: string,
  firstName?: string;
  gender?: 'male' | 'female' | 'unknown';
  lastName?: string;
  nickname?: string;
  postalCode?: string;
  street?: string;
  status?: 'error';
}



// WEBPACK FOOTER //
// ./src/lib/types/Profile.ts